/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const BarLineChart = ({
  labels = [],
  barData1 = [],
  barData2 = [],
  lineData1 = [],
  lineData2 = [],
  barLabel1 = "Bar 1",
  barLabel2 = "Bar 2",
  lineLabel1 = "Line 1",
  lineLabel2 = "Line 2",
  height = 320,
  noteData = ""
}) => {

  const safeBar1 = Array.isArray(barData1) ? barData1 : [];
  const safeBar2 = Array.isArray(barData2) ? barData2 : [];
  const safeLine1 = Array.isArray(lineData1) ? lineData1 : [];
  const safeLine2 = Array.isArray(lineData2) ? lineData2 : [];

  const stackedBarTotals = safeBar1.map((val, i) => val + (safeBar2[i] || 0));
  const maxBarValue = Math.max(...stackedBarTotals, 0);

  const maxLineValue = Math.max(...safeLine1, ...safeLine2, 0);

  const yMax = maxBarValue + 100;
  const y1Max = maxLineValue + 100;

  const totalStack1 = safeBar1.map((v, i) => (v || 0) - (safeBar2[i] || 0));
  const totalStack2 = safeLine1.map((v, i) => (v || 0) - (safeLine2[i] || 0));

  const data = {
    labels,
    datasets: [
      {
        type: "bar",
        label: barLabel1,
        data: totalStack1,
        backgroundColor: "#3B82F6",
        borderRadius: 3,
        stack: "stack1",
        yAxisID: "y",
        order: 1,
        datalabels: {
          formatter: (v) => v || "",
          color: "#ffffff",
          anchor: "center",
          align: "center",
          rotation: 90,
          font: { size: 8 },
        },
      },
      {
        type: "bar",
        label: barLabel2,
        data: safeBar2,
        backgroundColor: "#95B2F1",
        borderRadius: 3,
        stack: "stack1",
        yAxisID: "y",
        order: 1,
        datalabels: {
          labels: {
            value: {
              anchor: "center",
              align: "center",
              color: "#374151",
              font: { weight: "bold", size: 8 },
              formatter: (value) => value || "",
            },
            total: {
              display: (context) => {
                const i = context.dataIndex;
                const v1 = totalStack1[i] || 0;
                const v2 = safeBar2[i] || 0;
                return v1 + v2 >= v1;
              },
              anchor: "end",
              align: "top",
              offset: 6,
              font: { weight: "bold", size: 11 },
              formatter: (value, context) => {
                const i = context.dataIndex;
                return safeBar1[i] || "";
              }
            }
          }
        }
      },
      {
        type: "bar",
        label: lineLabel1,
        data: totalStack2,
        backgroundColor: "#0B4358",
        borderRadius: 3,
        stack: "stack2",
        yAxisID: "y1",
        order: 2,
        datalabels: {
          labels: {
            value: {
              formatter: (value) =>
                value ? `₹${Number(value).toFixed(2)}Crs` : "",
              color: "#ffffff",
              anchor: "center",
              align: "center",
              rotation: 90,
              font: { weight: "bold", size: 8 },
            },

            total: {
              display: (context) => {
                const i = context.dataIndex;
                const v2 = safeLine2[i] || 0;
                return v2 < 0;
              },
              anchor: "end",
              align: "top",
              offset: 6,
              font: { weight: "bold", size: 11 },
              formatter: (value, context) => {
                const i = context.dataIndex;
                const total = safeLine1[i];
                return total ? `₹${Number(total).toFixed(2)}Crs` : "";
              }
            }
          }
        }
      },
      {
        type: "bar",
        label: lineLabel2,
        data: safeLine2,
        backgroundColor: "#00E6A1",
        borderRadius: 3,
        stack: "stack2",
        yAxisID: "y1",
        order: 2,
        datalabels: {
          labels: {
            value: {
              anchor: "center",
              align: "center",
              formatter: (value) =>
                value ? `₹${Number(value).toFixed(2)}Crs` : "",
            },
            total: {
              display: (context) => {
                const i = context.dataIndex;
                const v1 = totalStack2[i] || 0;
                const v2 = safeLine2[i] || 0;
                return v1 + v2 >= v1;
              },
              anchor: "end",
              align: "top",
              offset: 6,
              font: { weight: "bold", size: 11 },
              formatter: (value, context) => {
                const i = context.dataIndex;
                const total = safeLine1[i];
                return total ? `₹${Number(total).toFixed(2)}Crs` : "";
              }
            }
          }
        }
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 20 } },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 12,
          boxHeight: 12,
          font: { size: 12 },
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      datalabels: {
        display: true,
        color: "#374151",
        anchor: "center",
        align: "center",
        font: { weight: "bold", size: 8 },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        max: yMax,
        position: "left",
        title: {
          display: true,
          text: "Counts",
        },
      },
      y1: {
        beginAtZero: true,
        max: y1Max,
        position: "right",
        grid: { drawOnChartArea: false },
        title: {
          display: true,
          text: "Amount (₹ Crs)",
        },
      },
    },
  };

  return (
    // <div style={{ width: "100%", height }}>
    //   <Chart type="bar" data={data} options={options} />
    // </div>
    <div>
      <div style={{ width: "100%", height }}>
        <Chart type="bar" data={data} options={options} />
      </div>
      <span style={{ fontSize: "10px" }}>Note: {noteData}</span>
    </div>
  );
};

export default BarLineChart;